import React from 'react';
import { Trash2 } from 'lucide-react';
import { ReachAssessment } from '../../../services/reachService';


const SCORE_LABEL: Record<number, string> = { 1: 'Not yet', 2: 'Emerging', 3: 'Established', 4: 'Embedded' };
const TYPE_LABELS: Record<string, string> = {
  champion: 'Champion', executive: 'Executive', 'practice-leader': 'Practice Leader', user: 'End User', general: 'General'
};

interface Props {
  assessments: ReachAssessment[];
  onDelete: (id: string) => void;
}

export const ResultsRespondentTable: React.FC<Props> = ({ assessments, onDelete }) => {
  if (!assessments.length) return (
    <div className="py-12 text-center text-slate-400 text-sm">No respondents yet.</div>
  );

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="border-b border-[#e2e8f0] bg-slate-50/50">
            <th className="text-left py-3 px-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Name</th>
            <th className="text-left py-3 px-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Role</th>
            <th className="text-left py-3 px-4 text-xs font-bold text-slate-500 uppercase tracking-wider">Type</th>
            <th className="text-center py-3 px-4 text-xs font-bold text-slate-500 uppercase tracking-wider" colSpan={5}>Individual (R·E·A·C·H)</th>
            <th className="text-center py-3 px-4 text-xs font-bold text-slate-500 uppercase tracking-wider" colSpan={5}>Organisational</th>
            <th className="py-3 px-4 w-10" />
          </tr>
        </thead>
        <tbody className="divide-y divide-[#e2e8f0]">
          {assessments.map(a => (
            <tr key={a.id} className="hover:bg-slate-50/30">
              <td className="py-3 px-4 font-medium text-navy">{a.respondentName}</td>
              <td className="py-3 px-4 text-slate-500">{a.role || '—'}</td>
              <td className="py-3 px-4">
                <span className="text-xs font-semibold text-slate-600 bg-slate-100 px-2 py-0.5 rounded-full">{TYPE_LABELS[a.type] ?? a.type}</span>
              </td>
              {(['r', 'e', 'a', 'c', 'h'] as const).map(s => (
                <td key={`i_${s}`} className="py-3 px-1 text-center">
                  <span className="text-xs font-semibold text-slate-700">{a.individual[s] ?? '—'}</span>
                </td>
              ))}
              {(['r', 'e', 'a', 'c', 'h'] as const).map(s => (
                <td key={`o_${s}`} className="py-3 px-1 text-center">
                  <span className="text-xs font-semibold text-slate-700">{a.organisational[s] ?? '—'}</span>
                </td>
              ))}
              <td className="py-3 px-4">
                <button onClick={() => onDelete(a.id)} className="text-slate-300 hover:text-red-500 transition-colors">
                  <Trash2 size={14} />
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
